import { useEffect, useState } from 'react';

function getViewport() {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return { isMobile: Math.min(width, height) < 768, isLandscape: width > height };
}

export function useViewport() {
  const [viewport, setViewport] = useState(getViewport);

  useEffect(() => {
    const update = () => setViewport(getViewport());
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return viewport;
}
